<template>
  <footer
    :class="[{ footer: true, footerStyle1: reliability.gridOn, footerStyle2: !reliability.gridOn }, { 'noselect': true }]">
    <div class="vPosition">
      <div>
        <img v-if="user && src" :src="src" width="80" height="40" :alt="$t('logo-da-unidade')" id="footer-logo" />
        <span v-else-if="!user" style="color: #fff;"><strong>GDI/PGDI</strong></span>
      </div>
      <div v-if="user && unitName" class="unitInfo">{{ unitName.toUpperCase() }}</div>
    </div>
    <div class="reportBox" v-if="infoReport.show">
      <div class="globalBoxInfo vPosition">
        <span>{{ dt1 }}</span>
        <span></span>
        <span>{{ dt2 }}</span>
      </div>
    </div>
    <span v-if="msg != null" :class="[{ msgTxt: true }, { vPosition: true }, { unitNameDivisor: reliability.pgdi }]">{{ msg }}</span>
    <div class="globalBox" v-if="reliability.pgdi">
      <div class="globalBoxHeader vPosition">{{ $t('aderencia-global') }}</div>
      <div class="globalBoxInfo vPosition">
        <span>{{ reliability.a.replace(',', '.') | numberFormat }}</span>
        <span>{{ reliability.b.replace(',', '.') | numberFormat }}</span>
        <span>{{ reliability.c.replace(',', '.') | numberFormat }}</span>
      </div>
    </div>
    <div class="globalBox" v-else-if="reliability.daily && !reliability.pgdi">
      <div class="globalBoxHeader vPosition">{{ $t('aderencia-global-0') }}</div>
      <div class="globalBoxInfo vPosition">
        <span>{{ reliability.daily.replace(',', '.') | numberFormat }}</span>
      </div>
    </div>
    <span class="pentagroTxt vPosition">{{ $t('pentagro-c-desde-2013') }}</span>
  </footer>
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
import { urlMainAPI } from '../../global';

var footerPentagro = null;

export default {
  name: "Footer",
  computed: mapState(["user", "msg", "dt1", "dt2", "infoReport", "reliability", "unitName"]),
  watch: { },
  data: function () {
    return {
      year: null,
      secondType: false,
      src: null
    }
  },
  filters: {
    numberFormat(num) {
      return parseFloat(num).toFixed(2) + " %"
    }
  },
  methods: {
    setCurrentYear() {
      let currentYear = new Date;
      this.year = currentYear.getFullYear();
    },

    async loadImage() {
      let url = urlMainAPI;
      await axios.get(`${url}/getfooter`, { responseType: 'blob' })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result;
          }
        })
        .catch(ex => {
          console.error(ex);
        });
    },

    checkUser() {
      if (this.user) {
        this.loadImage()
        clearInterval(footerPentagro)
      }
    }
  },
  async created() {
    footerPentagro = setInterval(() => { this.checkUser() }, 500)
    this.setCurrentYear();
  }
};
</script>

<style scoped>
.footer {
  grid-area: footer;
  width: 100%;
  height: 40px;
  background-color: #000;
  color: #fff;
  padding: 0 10px;
  display: grid;
}

.footerStyle1 {
  grid-template-columns: 1fr 2fr 2fr 1fr;
}

.footerStyle2 {
  grid-template-columns: 1fr 1fr 1fr;
}

.footer>img {
  max-height: 40px;
  max-width: 129px;
}

.msgTxt {
  font-weight: 400;
  font-size: 0.9em;
  letter-spacing: 1px;
  text-align: center;
  justify-content: center;
  /* border-left: #fff 1px solid; */
  /* border-right: #fff 1px solid; */
}

.unitNameDivisor {
  border-left: #fff 1px solid;
}


.vPosition {
  display: flex;
  align-items: center;
}

.pentagroTxt {
  justify-content: flex-end;
}

.footerPosition {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.globalBox {
  display: grid;
  grid-template-rows: 20px 20px;
  border-left: #fff 1px solid;
  border-right: #fff 1px solid;
}

.reportBox {
  display: grid;
  border-left: #fff 1px solid;
  border-right: #fff 1px solid;
}

.globalBoxHeader {
  justify-content: center;
}

.globalBoxInfo {
  justify-content: space-evenly;
}

.unitInfo {
  font-size: max(11px, 0.8vw);
  letter-spacing: 0.5px;
  margin: 10px;
}

@media only screen and (max-width: 1420px) {
  .unitInfo {
    display: none;
  }

  .unitNameDivisor {
    border-left: none;
  }
}

@media only screen and (max-width: 1055px) {
  .msgTxt {
    font-size: 0.8em;
  }

  .pentagroTxt {
    font-size: 0.8em;
  }

  .globalBox, .reportBox {
    font-size: 0.8em;
  }
}

@media only screen and (max-width: 990px) {
  .footerStyle1 {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .footerStyle2 {
    grid-template-columns: 1fr 2fr 1fr;
  }
}

@media only screen and (max-width: 850px) {
  .msgTxt {
    font-size: 0.7em;
  }

  .globalBox, .reportBox {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 760px) {
  .msgTxt {
    font-size: 0.65em;
  }

  .globalBox, .reportBox {
    font-size: 0.65em;
  }
}

@media only screen and (max-width: 688px) {
  .footerStyle1 {
    grid-template-columns: 1fr 2fr 1fr;
  }

  .globalBox, .reportBox {
    display: none;
  }
}

@media only screen and (max-width: 620px) {

  .footerStyle1,
  .footerStyle2 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media only screen and (max-width: 597px) {
  .msgTxt {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 555px) {
  .msgTxt {
    font-size: 0.65em;
  }

  .pentagroTxt {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 540px) {

  .footerStyle1,
  .footerStyle2 {
    grid-template-columns: 2fr 3fr 2fr;
  }
}

@media only screen and (max-width: 504px) {
  .msgTxt {
    font-size: 0.6em;
  }

  .pentagroTxt {
    font-size: 0.6em;
  }
}

@media only screen and (max-width: 472px) {
  .msgTxt {
    font-size: 0.6em;
  }

  .pentagroTxt {
    font-size: 0.6em;
  }
}

@media only screen and (max-width: 441px) {
  .msgTxt {
    font-size: 0.55em;
  }

  .pentagroTxt {
    font-size: 0.55em;
  }
}

@media only screen and (max-width: 390px) {
  .msgTxt {
    font-size: 0.5em;
  }

  .pentagroTxt {
    font-size: 0.5em;
  }
}
</style>
